module.exports = __webpack_public_path__ + "../front/img/568_3skuffer+trådkurv+hylder.da1d860c.svg";